import { type ReactNode, createContext, useContext } from "react";
import { useShallow } from "zustand/react/shallow";
import type {
  ImportStore,
  ImportStoreState,
} from "./file-to-storydoc-generation.store";

const ImportStoreContext = createContext<ImportStore | null>(null);

export const ImportStoreProvider = ({
  store,
  children,
}: {
  store: ImportStore;
  children: ReactNode;
}) => (
  <ImportStoreContext.Provider value={store}>
    {children}
  </ImportStoreContext.Provider>
);

export const useImportStoreApi = (): ImportStore => {
  const store = useContext(ImportStoreContext);
  if (!store)
    throw new Error(
      "useImportStoreApi must be used inside ImportStoreProvider",
    );
  return store;
};

export const useImportStore = <U,>(selector: (s: ImportStoreState) => U): U =>
  useImportStoreApi()(useShallow(selector));
